import templateUrl from './edit-rogers-payout-policy.component.html';

export const EditRogersPayoutPolicyComponent = {
    controller: EditRogersPayoutPolicyController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        productCommissionPolicies: "<",
        multiPlayCommissionPolicies: "<",
        payoutPolicy: "<",
        isAdminView: "<",
        isReadOnly: "<?"
    }
};

function EditRogersPayoutPolicyController() {
    'ngInject';
    const vm = this;


    vm.filterContentProductCommission = filterContentProductCommission;
    vm.filterTSUProductCommission = filterTSUProductCommission;
    vm.onChangePayoutAmount = onChangePayoutAmount;
    vm.onChangeRepPayoutAmount = onChangeRepPayoutAmount;

    vm.$onInit = onInit;

    function onInit() {
        vm.loaded = true;
    }

    function filterContentProductCommission(policy) {
        return policy.ProductLine.Name === "Content";
    }

    function filterTSUProductCommission(policy) {
        return policy.ProductLine.Name !== "Content";
    }

    function onChangePayoutAmount(policy) {
        policy.isPayoutModified = true;
        const repAmount = vm.payoutPolicy.SplittingModifierType === "Percent"
            ? policy.PayoutAmount * vm.payoutPolicy.RepPayoutSplittingModifier
            : vm.payoutPolicy.RepPayoutSplittingModifier;
        policy.RepPayoutAmount = repAmount;
        policy.isRepPayoutModified = true;

    }

    function onChangeRepPayoutAmount(policy) {
        policy.isRepPayoutModified = true;
    }
}
